import {
  PayeeRequirement,
  RequirementType
} from "@wingspanhq/wingspan-api-sdk";

/**
 * Priority mapping for requirement types.
 * Lower numbers appear first in sorted lists. Types without an entry (the SDK
 * members this module does not render) sort last.
 */
const REQUIREMENT_TYPE_PRIORITY: Partial<Record<RequirementType, number>> = {
  [RequirementType.REGISTRATION]: 1,
  [RequirementType.TAX_VERIFICATION]: 2,
  [RequirementType.PAYOUT_METHOD]: 3,
  [RequirementType.SIGNATURE]: 4,
  [RequirementType.DOCUMENT_UPLOAD]: 4,
  [RequirementType.BACKGROUND_CHECK]: 4,
  [RequirementType.BIOMETRIC_IDENTITY_VERIFICATION]: 4,
  [RequirementType.INSURANCE_COVERAGE]: 4
};

/**
 * Sorts requirements by priority order:
 * 1. Registration
 * 2. Tax Verification
 * 3. Payout Method
 * 4. Others (Signature, DocumentUpload, BackgroundCheck, IdentityVerification, InsuranceCoverage)
 *
 * @param requirements - Array of requirements to sort
 * @returns New array sorted by priority (does not mutate original)
 */
export function sortRequirementsByPriority<T extends PayeeRequirement>(
  requirements: T[]
): T[] {
  return [...requirements].sort((a, b) => {
    const priorityA = (a.type && REQUIREMENT_TYPE_PRIORITY[a.type]) ?? 999;
    const priorityB = (b.type && REQUIREMENT_TYPE_PRIORITY[b.type]) ?? 999;
    return priorityA - priorityB;
  });
}
